import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.113 4.79a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.368 7.724 7.724 0 0 1 0 11.047c-3.1 3.03-8.2 3.03-11.3 0a7.723 7.723 0 0 1 0-11.047.93.93 0 0 0 0-1.368.98.98 0 0 0-1.4 0c-4 3.812-4 10.069-.1 13.882 2 1.857 4.5 2.835 7.1 2.835s5.1-.978 7.1-2.835a9.7 9.7 0 0 0 0-13.882m-7.1 6.94c.6 0 1-.39 1-.977V.977c0-.586-.4-.977-1-.977s-1 .39-1 .977v9.776c0 .587.4.978 1 .978z"
    }, null, -1)
  ]))]))
}
export default { render: render }